import * as ACTIONS from "./actionTypes";

const initialState = {
  carModels: [],
};

function carModelsReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_CAR_MODELS_SUCCESS: {
      return {
        ...state,
        ...{ carModels: payload.list },
      };
    }
    case ACTIONS.RESET_CAR_MODELS: {
      return {
        ...state,
        ...{ carModels: [] },
      };
    }

    default:
      return state;
  }
}

export default carModelsReducer;
